import {Button, Tag} from "antd";
import RequestLogRowMenu from "./RequestLogRowMenu";
import {EyeOutlined} from "@ant-design/icons";

export default function requestLogColumns(t, onViewJson)
{
    return [
        {
            title: t('Id'),
            dataIndex: 'id',
            key: 'id',
            columnName: 'id',
            width: 120,
            render: (text, record) => (
                <RequestLogRowMenu row={record} />
            )
        },
        {
            title: t('Date'),
            dataIndex: 'createdDate',
            key: 'createdDate',
            columnName: 'createdDate',
            width: 160,
            render: (text) => text ? new Date(text).toLocaleString() : '-',
        },
        {
            title: t('User'),
            dataIndex: 'userName',
            key: 'userName',
            columnName: 'userName',
            width: 120,
            render: (userName, record) => {
                if (userName) return userName;
                
                // For login attempts, try to extract username from body
                if (record.isLoginAttempt && record.requestBody) {
                    try {
                        const body = typeof record.requestBody === 'string' 
                            ? JSON.parse(record.requestBody) 
                            : record.requestBody;
                        // Check common username field names
                        const loginUser = body.username || body.Username || 
                                         body.user || body.User || 
                                         body.email || body.Email ||
                                         body.phone || body.Phone;
                        if (loginUser) {
                            return <span style={{fontStyle: 'italic', color: '#666'}}>{loginUser}</span>;
                        }
                    } catch (e) {
                        // Ignore parse errors
                    }
                }
                return '-';
            }
        },
        {
            title: t('App Client'),
            dataIndex: 'appClientName',
            key: 'appClientName',
            columnName: 'appClientName',
            width: 120,
        },
        {
            title: t('IP'),
            dataIndex: 'ipAddress',
            key: 'ipAddress',
            columnName: 'ipAddress',
            width: 120,
        },
        {
            title: t('Method'),
            dataIndex: 'httpMethod',
            key: 'httpMethod',
            columnName: 'httpMethod',
            width: 80,
            render: (text) => {
                const colors = {
                    'GET': 'green',
                    'POST': 'blue',
                    'PUT': 'orange',
                    'DELETE': 'red',
                    'PATCH': 'purple'
                };
                return <Tag color={colors[text] || 'default'}>{text}</Tag>
            }
        },
        {
            title: t('Path'),
            dataIndex: 'path',
            key: 'path',
            columnName: 'path',
            ellipsis: true,
        },
        {
            title: t('Status'),
            dataIndex: 'statusCode',
            key: 'statusCode',
            columnName: 'statusCode',
            width: 80,
            render: (code) => {
                let color = 'green';
                if (code >= 400 && code < 500) color = 'orange';
                if (code >= 500) color = 'red';
                return <Tag color={color}>{code}</Tag>
            }
        },
        {
            title: t('Time (ms)'),
            dataIndex: 'elapsedMs',
            key: 'elapsedMs',
            columnName: 'elapsedMs',
            width: 90,
            render: (ms) => {
                let color = 'green';
                if (ms > 1000) color = 'orange';
                if (ms > 5000) color = 'red';
                return <span style={{color}}>{ms}</span>
            }
        },
        {
            title: t('Login'),
            dataIndex: 'isLoginAttempt',
            key: 'isLoginAttempt',
            columnName: 'isLoginAttempt',
            width: 80,
            render: (isLogin, record) => {
                if (!isLogin) return '-';
                return record.isFailedLogin 
                    ? <Tag color="red">{t('Failed')}</Tag>
                    : <Tag color="green">{t('Success')}</Tag>
            }
        },
        {
            title: t('Body'),
            dataIndex: 'requestBody',
            key: 'requestBody',
            columnName: 'requestBody',
            width: 80,
            render: (body, record) => {
                if (!body) return '-';
                return (
                    <Button 
                        size="small" 
                        icon={<EyeOutlined />}
                        onClick={() => onViewJson && onViewJson(body)}
                    />
                )
            }
        },
    ]
}
